"use strict";
/**
 * Driver for Miniapp
 **/
Object.defineProperty(exports, "__esModule", { value: true });
function cached(fn) {
    var cache = Object.create(null);
    return function cachedFn(str) {
        return cache[str] || (cache[str] = fn(str));
    };
}
// opacity -> opa
// fontWeight -> ntw
// lineHeight|lineClamp -> ne[ch]
// flex|flexGrow|flexPositive|flexShrink|flexNegative|boxFlex|boxFlexGroup|zIndex -> ex(?:s|g|n|p|$)
// order -> ^ord
// zoom -> zoo
// gridArea|gridRow|gridRowEnd|gridRowSpan|gridRowStart|gridColumn|gridColumnEnd|gridColumnSpan|gridColumnStart -> grid
// columnCount -> mnc
// tabSize -> bs
// orphans -> orp
// windows -> ows
// animationIterationCount -> onit
// borderImageOutset|borderImageSlice|borderImageWidth -> erim
var NON_DIMENSIONAL_REG = /opa|ntw|ne[ch]|ex(?:s|g|n|p|$)|^ord|zoo|grid|orp|ows|mnc|^columns$|bs|erim|onit/i;
var EVENT_PREFIX_REG = /^on[A-Z]/;
var CLASS_NAME = 'className';
var CLASS = 'class';
var STYLE = 'style';
var CHILDREN = 'children';
var TEXT_CONTENT_ATTR = 'textContent';
var CREATE_COMMENT = 'createComment';
var CREATE_TEXT_NODE = 'createTextNode';
var SET_ATTRIBUTE = 'setAttribute';
var REMOVE_ATTRIBUTE = 'removeAttribute';
var EMPTY = '';
var isDimensionalProp = cached(function (prop) { return !NON_DIMENSIONAL_REG.test(prop); });
var isEventProp = cached(function (prop) { return EVENT_PREFIX_REG.test(prop); });
function createBody() {
    return document.body;
}
function createEmpty() {
    return document[CREATE_COMMENT](EMPTY);
}
function createText(text) {
    return document[CREATE_TEXT_NODE](text);
}
function updateText(node, text) {
    node[TEXT_CONTENT_ATTR] = text;
}
/**
* @param {string} type node type
* @param {object} props element properties
*/
function createElement(type, props) {
    var style;
    var attrs = {};
    var events = [];
    for (var prop in props) {
        var value = props[prop];
        if (prop === CHILDREN)
            continue;
        if (value !== null) {
            if (prop === STYLE) {
                style = value;
            }
            else if (isEventProp(prop)) {
                events.push({
                    name: prop.slice(2).toLowerCase(),
                    handler: value
                });
            }
            else {
                if (prop === CLASS_NAME) {
                    prop = CLASS;
                }
                attrs[prop] = value;
            }
        }
    }
    // @ts-ignore
    var node = document._createElement({
        tagName: type,
        document: document,
        attrs: attrs
    });
    if (style) {
        setStyle(node, style);
    }
    events.forEach(function (_a) {
        var name = _a.name, handler = _a.handler;
        node.addEventListener(name, handler);
    });
    return node;
}
function appendChild(node, parent) {
    return parent.appendChild(node);
}
function removeChild(node, parent) {
    parent = parent || node.parentNode;
    // Maybe has been removed when remove child
    if (parent) {
        parent.removeChild(node);
    }
}
function replaceChild(newChild, oldChild, parent) {
    parent = parent || oldChild.parentNode;
    parent.replaceChild(newChild, oldChild);
}
function insertAfter(node, after, parent) {
    parent = parent || after.parentNode;
    var nextSibling = after.nextSibling;
    if (nextSibling) {
        // Performance improve when node has been existed before nextSibling
        if (nextSibling !== node) {
            insertBefore(node, nextSibling, parent);
        }
    }
    else {
        appendChild(node, parent);
    }
}
function insertBefore(node, before, parent) {
    parent = parent || before.parentNode;
    parent.insertBefore(node, before);
}
function addEventListener(node, eventName, eventHandler) {
    return node.addEventListener(eventName, eventHandler);
}
function removeEventListener(node, eventName, eventHandler) {
    return node.removeEventListener(eventName, eventHandler);
}
function removeAttribute(node, propKey) {
    if (propKey === CLASS_NAME)
        propKey = CLASS;
    if (propKey in node) {
        node[propKey] = null;
    }
    node[REMOVE_ATTRIBUTE](propKey);
}
function setAttribute(node, propKey, propValue) {
    if (propKey === CLASS_NAME)
        propKey = CLASS;
    if (propKey in node) {
        node[propKey] = propValue;
    }
    else {
        node[SET_ATTRIBUTE](propKey, propValue);
    }
}
/**
* @param {object} node target node
* @param {object} style target node style value
*/
function setStyle(node, style) {
    for (var prop in style) {
        var value = style[prop];
        var convertedValue = void 0;
        if (typeof value === 'number' && isDimensionalProp(prop)) {
            convertedValue = value + 'rpx';
        }
        else {
            convertedValue = value;
        }
        // Support CSS custom properties (variables) like { --main-color: "black" }
        if (prop[0] === '-' && prop[1] === '-') {
            // reference: https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleDeclaration/setProperty.
            // style.setProperty do not support Camel-Case style properties.
            node.style.setProperty(prop, convertedValue);
        }
        else {
            node.style[prop] = convertedValue;
        }
    }
}
function beforeRender() { }
function afterRender() { }
/**
* Remove all children from node.
* @NOTE: Optimization at web.
*/
function removeChildren(node) {
    node.textContent = EMPTY;
}
exports.default = {
    createBody: createBody,
    createEmpty: createEmpty,
    createText: createText,
    updateText: updateText,
    createElement: createElement,
    appendChild: appendChild,
    removeChild: removeChild,
    replaceChild: replaceChild,
    insertAfter: insertAfter,
    insertBefore: insertBefore,
    addEventListener: addEventListener,
    removeEventListener: removeEventListener,
    removeAttribute: removeAttribute,
    setAttribute: setAttribute,
    setStyle: setStyle,
    beforeRender: beforeRender,
    afterRender: afterRender,
    removeChildren: removeChildren
};
